package com.havn.app.core.localization

enum class HavnLanguage(
    val code: String,
    val displayName: String,
    val nativeName: String
) {
    English("en", "English", "English"),
    Slovak("sk", "Slovak", "Slovenčina"),
    German("de", "German", "Deutsch"),
    French("fr", "French", "Français"),
    Czech("cs", "Czech", "Čeština"),
    Spanish("es", "Spanish", "Español"),
    Italian("it", "Italian", "Italiano"),
    Croatian("hr", "Croatian", "Hrvatski"),
    Portuguese("pt", "Portuguese", "Português"),
    Dutch("nl", "Dutch", "Nederlands"),
    Polish("pl", "Polish", "Polski"),
    Hungarian("hu", "Hungarian", "Magyar"),
    Romanian("ro", "Romanian", "Română");

    companion object {
        fun fromCode(code: String?): HavnLanguage =
            entries.firstOrNull { it.code == code } ?: English

        fun fromLocaleCode(code: String?): HavnLanguage {
            val normalized = code
                ?.trim()
                ?.lowercase()
                ?.replace('_', '-')
                ?.takeIf { it.isNotBlank() }
                ?: return English
            val languageCode = normalized.substringBefore("-")
            return entries.firstOrNull { it.code == languageCode } ?: English
        }
    }
}
